module.exports = __webpack_public_path__ + "img/medium_brown.4f445760.svg";